import { WALKTHROUGH_TASK_ITEMS_CRUD_ACTION_CREATORS } from '../actions/walkthrough_task_items_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const walkthroughTaskItemsRestCrudThunksForBuyer = new RestCrudThunks(
	'task_items',
	'task_item',
	'taskItem',
	'taskItems',
	WALKTHROUGH_TASK_ITEMS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'walkthroughs/'
);
export const walkthroughTaskItemsRestCrudThunksForSupplier = new RestCrudThunks(
	'task_items',
	'task_item',
	'taskItem',
	'taskItems',
	WALKTHROUGH_TASK_ITEMS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'walkthroughs/'
);
